
/* eslint-disable vue/no-mutating-props */
// Editable "on file" fields for a returning client (primary or attendee). The
// admin can correct phone, ZIP/county, coverage date and Medicare parts on the
// recorded line; toClientEntry sends them and book.py persists them onto the
// existing account. Identity (name/DOB/email) stays read-only — it keys the
// account. `target` is an orchestrator-owned logic.js person, mutated in place.
import { COPY, MEDICARE_PARTS_OPTIONS } from './copy'
import zipCounty from './zip-county'
import AddressSearch from '~/components/AddressSearch.vue'

export default {
    components: { AddressSearch },
    mixins: [zipCounty],
    props: {
        target: { type: Object, required: true },
        consentLabel: { type: String, default: COPY.s2.consentClient },
    },
    data () {
        return { COPY, partsOptions: MEDICARE_PARTS_OPTIONS }
    },
    computed: {
        // Defensive: this component otherwise has no $store dependency
        // (unlike ClientInfoCard, which already needs it for `genders`), so
        // guard rather than assume it's present.
        usStates () {
            return (this.$store && this.$store.getters.usStates) || []
        },
        // The coverage date on the account, shown under the (deliberately
        // blank) input as context — the admin sees what's stored and that
        // leaving the box empty keeps it, without the stale date being
        // pre-typed for them to rubber-stamp. Formatted straight off the ISO
        // string: `new Date('2019-04-01')` parses as UTC midnight and would
        // render as 3/31/2019 in every US timezone.
        onFileCoverage () {
            const raw = (this.target.record && this.target.record.effective_date) || ''
            const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(raw))
            return m ? `${Number(m[2])}/${Number(m[3])}/${m[1]}` : ''
        },
    },
    methods: {
        // #689: ZIP first. onZip nulls state synchronously and the county
        // lookup only backfills state while it is still empty, so setting the
        // picked state right after means it wins over the county-derived one.
        onAddressPick (a) {
            this.onZip(a.zip_code || '')
            this.set('street_1', a.street_1 || '')
            this.set('street_2', a.street_2 || '')
            this.set('city', a.city || '')
            this.set('state', a.state || null)
        },
        // #680 Phase 2a: same override as ClientInfoCard.vue — see its
        // comment. An explicit state <select> now sits beside ZIP here too;
        // the mixin's applyCounty must not clobber an admin's own pick.
        applyCounty (c) {
            this.set('fips', c.fips)
            this.set('county', `${c.county || c.name}, ${c.state}`)
            if (!this.target.state) this.set('state', c.state || null)
        },
    },
}
